import React from 'react';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { UserService } from '../../services/UserService';
import useRequest from '../../hooks/useRequest';

import MainLayout from '../../components/Layouts/MainLayout';


import GradientButton from '../../components/atoms/GradientButton';


import './styles.scss';

const PendingUnsubscribeView = (props) => {
    const history = useHistory();

    const {
        submitted, success, message,
        beforeSubmit, afterSubmit, showSuccess, showError,
        dealWithError
    } = useRequest();

    return (
        <MainLayout>
            <div className="unsubscribe-request-container">
                <div className="unsubscribe-request-content">
                    <form className="unsubscribe-request-form" >
                        <h1 className="unsubscribe-request-title">Solicitar la baja de mi usuario</h1>
                        <h2 className="unsubscribe-request-subtitle">Se ha enviado un correo electrónico para que confirmes la baja de tu usuario de la Oficina Virtual.</h2>
                    </form>
                </div>
            </div>
        </MainLayout>
    );
}

export default withTranslation()(PendingUnsubscribeView);